var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_769_18338)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4844 93.2812H22.5156C21.691 93.2812 20.9001 92.9537 20.317 92.3705C19.7338 91.7874 19.4062 90.9965 19.4062 90.1719V15.5469C19.4062 14.7222 19.7338 13.9313 20.317 13.3482C20.9001 12.7651 21.691 12.4375 22.5156 12.4375H78.4844C79.309 12.4375 80.0999 12.7651 80.683 13.3482C81.2662 13.9313 81.5938 14.7222 81.5938 15.5469V90.1719C81.5938 90.9965 81.2662 91.7874 80.683 92.3705C80.0999 92.9537 79.309 93.2812 78.4844 93.2812Z",
    fill: "#009DE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.375 87.0625H25.625V18.6562H75.375V87.0625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8438 28.8324H50.5V34.4858H31.8438V28.8324ZM31.8438 40.1392H69.1562V45.7926H31.8438V40.1392ZM31.8438 51.446H69.1562V57.0994H31.8438V51.446ZM31.8438 62.7528H69.1562V68.4062H31.8438V62.7528ZM50.5 6.21875C49.4147 6.22471 48.3501 6.48875 47.4119 6.98464C46.4736 7.48054 45.6945 8.19101 45.1519 9.04545H38.0625V11.8722H62.9375V9.04545H55.8481C55.3055 8.19101 54.5264 7.48054 53.5881 6.98464C52.6499 6.48875 51.5853 6.22471 50.5 6.21875Z",
    fill: "#EE3D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9375 12.4375H38.0625V18.6562H62.9375V12.4375Z",
    fill: "#00267A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9375 18.6562H38.0625V21.7656H62.9375V18.6562Z",
    fill: "#EE3D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9375 37.3125C66.372 37.3125 69.1562 34.5283 69.1562 31.0938C69.1562 27.6592 66.372 24.875 62.9375 24.875C59.503 24.875 56.7188 27.6592 56.7188 31.0938C56.7188 34.5283 59.503 37.3125 62.9375 37.3125Z",
    fill: "#EE3D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6926 99.1367C90.0783 97.2919 95.3809 88.9984 93.5361 80.6126C91.6913 72.2269 83.3978 66.9243 75.012 68.7691C66.6262 70.6139 61.3237 78.9074 63.1685 87.2932C65.0133 95.679 73.3068 100.981 81.6926 99.1367Z",
    fill: "#EE3D8B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.81762,
    height: 19.1519,
    transform: "matrix(0.767332 0.64125 -0.644906 0.764262 84.2153 75.2925)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.76841,
    height: 10.4643,
    transform: "matrix(0.660034 -0.751236 0.754342 0.656481 67.5644 86.187)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_769_18338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.5,
    height: 99.5,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardPink);
export default __webpack_public_path__ + "static/media/Clipboard-Pink.b041f5468f61f28110056ff8aee407e7.svg";
export { ForwardRef as ReactComponent };